var ClipBoardUtils;
((ClipBoardUtils2) => {
  ClipBoardUtils2.readText = (window) => {
    return window.navigator.clipboard.readText();
  };
  ClipBoardUtils2.read = (window) => {
    return window.navigator.clipboard.read();
  };
  ClipBoardUtils2.writeText = (data, window) => {
    if (window.navigator.clipboard) {
      return window.navigator.clipboard.writeText(data);
    } else {
      return new Promise((resolve, reject) => {
        try {
          const textarea = document.createElement("textarea");
          textarea.value = data;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          const copyExec = document.execCommand("copy");
          document.body.removeChild(textarea);
          if (copyExec) {
            resolve();
          } else {
            reject(new Error("copy failed"));
          }
        } catch (err) {
          reject(err);
        }
      });
    }
  };
  ClipBoardUtils2.write = (data, clipboard = navigator.clipboard) => {
    return clipboard.write(data);
  };
})(ClipBoardUtils || (ClipBoardUtils = {}));
export {
  ClipBoardUtils
};
//# sourceMappingURL=ClipBoardUtils.js.map
